module.exports = __webpack_public_path__ + "1e98ff8d7b3c1b7af72300ecb6061be9.png";